import './mini-promp.scss'
import type { GridElement } from '@omnia/ui/src/lib'
import { CmsImage, CmsLinkComponent } from '@omnia/ui/src/lib'
import type { FC } from 'react'
import type { MiniPromoPropsApi } from '@/features/grid/miniPromo/models'

export const MiniPromo: FC<GridElement<MiniPromoPropsApi>> = ({ value: props }) => {
    return (
        <div className="mini-promo">
            <CmsImage containerClass="image" image={props.image} />
            <div className="headline-link">
                <h3 className="headline">{props.headline}</h3>
                <CmsLinkComponent className="link" link={props.link} />
            </div>
        </div>
    )
}
